module.exports = __webpack_public_path__ + "static/media/bbq-text-4.b1a6424a.jpg";